// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2pN5x","fileBtn":"File_fileBtn__3n4FB","closeBtn":"File_closeBtn__1q6QK","fileSelected":"File_fileSelected__2X9uR","disabled":"File_disabled__2nvzX"};